<template>
  <footer class="footer bottom-0 pt-2 d-flex justify-content-center pb-0 align-items-center">
    <div class="container-lg py-0 ">
      <div class="row footer-content d-flex justify-content-between">
        <div class="col-12 col-md-3 col-lg-4 text-xs-center py-1 py-md-0">
          <img src="/images/tribesuite.svg" alt="TribeHired Logo" class="brand-md mr-2" />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
}
</script>
